import { cn } from '@/lib/utils'

/**
 * Símbolo Flexibase (F vazado).
 * - `tile` (padrão, menu lateral): ladrilho azul-marinho no tema escuro, traço azul no claro.
 * - `document` (ata): traço branco no tema escuro, azul no claro; na impressão sempre azul.
 */
export function BrandMark({ className, variant = 'tile' }: { className?: string; variant?: 'tile' | 'document' }) {
  const onDark = variant === 'document' ? '/brand/flexibase-white.png' : '/brand/flexibase-dark.png'
  return (
    <span className={cn('relative inline-flex size-7 shrink-0', className)}>
      <img src="/brand/flexibase-light.png" alt="Flexibase" className="size-full dark:hidden print:!block" />
      <img src={onDark} alt="" aria-hidden className="hidden size-full dark:block print:!hidden" />
    </span>
  )
}
